<template>
  <div>

    <el-card :body-style="cardBodyStyle">

      <el-form :inline="true">
        <el-form-item style="margin-bottom: 0px;">
          <el-input v-model="query.appName" placeholder="请输入" size="small"></el-input>
        </el-form-item>



      </el-form>
    </el-card>

    <el-card :body-style="cardBodyStyle">
      <el-button type="primary" @click="handleSearchFromWX" size="small">查询当前</el-button>
      <el-button type="primary" plain @click="handleAdd" size="small">从数据库上传</el-button>
    </el-card>
    <el-card :body-style="cardBodyStyle">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-tree :data="dataWX" :props="defaultProps" @node-click="handleNodeClickWX"></el-tree></el-col>
        <el-col :span="6">
          <el-form :model="buttonWX" label-width="80px" label-position="right">
            <el-form-item label="用户编码" v-if="false">
              <el-input v-model="buttonWX.id" size="small"></el-input>
            </el-form-item>
            <el-form-item label="type">
              <el-input v-model="buttonWX.type" size="small"></el-input>
            </el-form-item>
            <el-form-item label="name">
              <el-input v-model="buttonWX.name" size="small"></el-input>
            </el-form-item>
            <el-form-item label="url">
              <el-input v-model="buttonWX.url" size="small"></el-input>
            </el-form-item>
            <el-form-item label="appid">
              <el-input v-model="buttonWX.appid" size="small"></el-input>
            </el-form-item>
            <el-form-item label="pagepath">
              <el-input v-model="buttonWX.pagepath" size="small"></el-input>
            </el-form-item>
            <el-form-item label="key">
              <el-input v-model="buttonWX.key" size="small"></el-input>
            </el-form-item>

          </el-form>
        </el-col>



        <el-col :span="6">
          <el-tree :data="data" :props="defaultProps"></el-tree></el-col>

      </el-row>
      <!--  <el-table :data="tableData" border highlight-current-row @header-dragend="handleDragend">
        <el-table-column type="index" label="序号" align="center" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="userCode" label="用户编码" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userName" label="用户名" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="userDesc" label="姓名" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="idCard" label="身份证号" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="140" header-align="center" align="center"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="memo" label="备注" width="140" header-align="center" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="addTime" label="添加日期" width="200" show-overflow-tooltip header-align="center"
          align="center">
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="200px">
          <template slot-scope="scope">
            <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" plain type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table> -->
    </el-card>

  </div>
</template>

<script>
  import axios from '@/axios'
  import tools from '@/tools'

  export default {
    data() {
      return {

        cardBodyStyle: tools.style.card,
        query: {
          appName: ''
        },
        data: {},
        dataWX: {},
        defaultProps: {
          children: 'subButton',
          label: 'name'
        },

        buttonWX: {},
        button: {}
      }
    },
    mounted() {

    },
    methods: {
      handleSearch() {

      },
      handleAdd() {
        var url = 'wx/Button/create.do'
        var param = {}
        axios.get(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
          } else {
            this.$message({
              type: 'error',
              message: '操作失败！' + response.data.msg,
            });
          }
        });
      },
      handleEdit(row) {

      },
      handleDelete(row) {


      },
      handleSearchFromWX() {
        var url = 'wx/Button/queryFromWX.do'
        var param = {}
        axios.get(url, param).then(response => {
          if (response.data.code == '0') {
            // console.log(typeof response.data.data)
            // console.log(response.data.data)
            // console.log(JSON.stringify(response.data.data))
            this.dataWX = response.data.data
          } else {
            this.$message({
              type: 'error',
              message: '操作失败！' + response.data.msg,
            });
          }
        });
      },

      handleNodeClickWX(data) {
        // console.log(data);
        this.buttonWX = data
      },


    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/official/button.vue